import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { NotFound as messages } from '../messages';

const ContentWrapper = styled.div`
  font-size: x-large;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
`;

export const NotFoundContent: VFC = () => (
  <ContentWrapper>
    <span>
      <FormattedMessage {...messages.contentText} />
      <span aria-label="Scared emoji" role="img">
        😱
      </span>
      ....
    </span>

    <span>
      <FormattedMessage {...messages.contentSubText} />
    </span>
  </ContentWrapper>
);
